<script setup lang="ts">
import { EPageSectionType } from '@/modules/adminModule/constants/pagesCMSconstants'
const hidden = ref(true)
// const i18nService = usei18nService()

// function hide() {
// 	hidden.value = true
// }
// function show() {
// 	hidden.value = false
// }

const props = defineProps<{
	pageType?: string
	page?: string
	disableAos?: boolean
}>()

const data = ref<
	| {
			[key: string]: any
	  }[]
	| undefined
>()

const { getLocaleLang } = usei18nService()

const pageSections = inject<Ref<IHomePageSectionModel[] | ICMSLocationContent[]>>('pageSections')!

if (!pageSections && props.pageType && props.page) {
	try {
		const paragraphs = await ApiService.fetchPageSectionByName(props.pageType, props.page, EPageSectionType.PARAGRAFS)
		if (paragraphs) data.value = paragraphs?.translations.find((t) => t.language === getLocaleLang())?.content
	} catch (error) {
		console.log(error)
	}
}

watch(
	() => pageSections?.value,
	(newValue) => {
		if (newValue) {
			const section = newValue.find((section) => section.name === EPageSectionType.PARAGRAFS)
			if (section) {
				data.value = section.translations.find((t) => t.language === getLocaleLang())?.content
			}
		}
	},
	{ immediate: true, deep: true },
)

// const hasText = computed(() => {
// 	if (!data.value) return false
// 	return data.value.some((item) => item.text)
// })

// const computedData = computed(() => {
// 	return data.value?.filter((item) => item.text)
// })
</script>

<template>
	<section class="seo-container" :data-hidden="hidden">
		<GlobalSEOSectionBanner :pageType="pageType" :page="page" />
		<!-- <div :data-aos="disableAos ? undefined : 'fade-up'" class="seo-container__list">
			<article v-for="(item, idx) in computedData" :key="idx" class="seo-container__item">
				<h4 class="seo-container__title" v-html="i18nService.$tDynamic('data.seo_section', item.translation_key_title || item.title)"></h4>
				<p class="seo-container__description" v-html="item.text"></p>
			</article>
			<div class="seo-container__gradient"></div>
			<ButtonPrimary class="seo-container__show-btn" @click="show">{{ $t('components.seo_section.read_more') }}</ButtonPrimary>
			<ButtonPrimary class="seo-container__hide-btn" @click="hide">{{ $t('components.seo_section.read_less') }}</ButtonPrimary>
		</div> -->
	</section>
</template>

<style lang="scss">
@import './SEOSection.scss';
</style>
